import { Component, OnInit } from '@angular/core';

import { UserService } from './shared/services/user.service';
import { SidebarService } from './shared/services/sidebar.service';
import { WEBINAR_REGISTER_URL } from './shared/components/banner-dialog/banner-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  webinarRegisterUrl = WEBINAR_REGISTER_URL;

  constructor(
    public userService: UserService,
    public sidebarService: SidebarService
  ) {}

  ngOnInit(): void {
    this.userService.getUserInfo();
  }
}
